export default "__VITE_ASSET__BPJNNp_S__"